import { useAuth } from '@/lib/auth/auth';
import type { DiscoveryEventDetail } from '@/lib/api/apiTypes';
import { locationStore } from '@/lib/location/location';
import { useQuery } from '@tanstack/react-query';

export const editableEventKeys = {
  all: ['editable-event'] as const,
  detail: (
    id: string,
    params: {
      latitude: number;
      longitude: number;
    }
  ) => ['editable-event', id, params] as const,
};

export function useEditableEvent(id?: string) {
  const request = useAuth((state) => state.request);
  const session = useAuth((state) => state.session);
  const coords = locationStore((state) => state.coords);

  return useQuery({
    queryKey: id
      ? editableEventKeys.detail(id, {
          latitude: coords.latitude,
          longitude: coords.longitude,
        })
      : editableEventKeys.all,
    enabled: Boolean(id && session?.accessToken),
    queryFn: async () => {
      if (!id) {
        throw new Error('Missing event id');
      }

      const params = new URLSearchParams({
        lat: String(coords.latitude),
        lng: String(coords.longitude),
      });

      return request<DiscoveryEventDetail>(`/events/${id}?${params.toString()}`);
    },
  });
}
